/* eslint-disable jsx-a11y/anchor-is-valid */
import { useIonViewWillEnter } from '@ionic/react';
import { Business } from 'model';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { useGetBusinessQuery } from '../api/BusinessApi';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { NoResults } from '../components/NoResults';
import { IconArrowBack, IconBusiness } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { QuirkIonPage } from '../components/QuirkIonPage';
import { QuirkLoader } from '../components/QuirkLoader';
import { BusinessDetailBody } from './BusinessDetailBody';

export const BusinessDetail: React.FC = () => {
	const { businessid } = useParams<{ businessid: Business['_id'] }>();
	const { data: business, refetch, isLoading } = useGetBusinessQuery(businessid, { skip: !businessid });
	const history = useHistory();

	useIonViewWillEnter(() => {
		refetch();
	});

	return (
		<QuirkIonPage roles={['anonymous', 'user']} name="Business Detail" data={{ business: businessid }}>
			<Header
				title={business?.name}
				left={
					<IconButton
						icon={<IconArrowBack />}
						onClick={() => history.goBack()}
						testId="businessDetailBackButton"
					/>
				}
			/>
			<QuirkIonContent flush>
				<QuirkLoader
					isLoading={isLoading}
					loadingMessage="Loading business..."
					data={business}
					noResults={
						<NoResults
							heading="No business found."
							subheading="There is no business here. Choose another."
							icon={<IconBusiness />}
						/>
					}
				>
					{business && <BusinessDetailBody business={business} showToolbar showClaim />}
				</QuirkLoader>
			</QuirkIonContent>
		</QuirkIonPage>
	);
};
